/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ea-adfs[_ngcontent-%COMP%]{margin-top:25px;margin-bottom:25px}.ea-adfs[_ngcontent-%COMP%]   .ea-adf-label[_ngcontent-%COMP%]{line-height:30px}"];
export { styles as styles };
